<template>
    <div id="wrap">
        <MainHeader title='선물 선택 현황'/>
        <section class="selection_present_status">
            <h5>{{this.goods.recvr_nm}}</h5>
                <ul class="product_select_list">
                    <li v-for="(recvr,i) in recvrList" :key="`${recvr.recvr_no}-${i}`"   :item="recvr"
                        :class="{choice:recvr.goods_sel ===1}"  >
                        <div class="func_area">
                            <span class="tag" v-if="recvr.goods_sel ===1"  >선택</span>
                            <a class="link"  @click.stop="$refs.goodDtl.searchGood($route.params.event_no, recvr.good_no)">상세보기 </a>
                        </div>
                        <div class="info">
                            <div class="thumb">
                                 <img :src="$store.getters['systemStore/getImgPath']+recvr.img_path" :alt="goods.good_nm">
                            </div>
                            <p class="product_name">{{recvr.good_nm}}</p>
                        </div>
                    </li>
                </ul>
            <Footer/>
        </section>
        <GoodDtl ref="goodDtl" :price_hidden="true" />
        <button class="content_btn" @click="$router.push('checkMsgRecept')" >이 전</button>

        <!-- alert -->
        <div class="popup check_msg_recept_01">
            <div class="popup_container">
                <header class="popup_header">안 내</header>
                <div class="popup_content">
                    <p v-html="alertMsg"></p>
                </div>
                <div class="popup_button">
                    <button class="btn_large" onclick="modal('check_msg_recept_01')">확 인</button>
                </div>
                
            </div>
            <div class="dimBg"></div>
        </div>

        <div class="popup check_msg_recept_02">
            <div class="popup_container">
                <header class="popup_header">안 내</header>
                <div class="popup_content">
                    <p v-html="alertMsg"></p>
                </div>
                <div class="popup_button">
                    <button class="btn_large" onclick="location.reload();">확 인</button>
                </div>
            </div>
            <div class="dimBg"></div>
        </div>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'
import GoodDtl from '@/components/GoodDtl.vue'
import {api} from '@/api/index.js'
import Footer from '@/components/MainFooter'
export default {
    
    name: 'GoodsRecept',

    data() {
        return{
            alertMsg: '',
            eventDtl: '',
            groupList: [],
            receptionState: null,
            recvrList: [],
            selectedGroupIndex: 0,
            selectedRecvr: {},
            goods: {
                recvr_nm: "",
                recvr_no: "" 
            },

        }
    },
    
    methods: {
        
        fnAlert1(msg) {
            this.alertMsg = msg;
            $('.check_msg_recept_01').addClass('active');
        },
        fnAlert2(msg) {
            this.alertMsg = msg;
            $('.check_msg_recept_02').addClass('active');
        } 
    },
    created() {

        this.goods.recvr_no = this.$route.query.recvr_no;
        api.postAsync('/event/goodsRecept.do',{event_no: this.$route.params.event_no, recvr_no : this.goods.recvr_no })
        .then(data=>{
            //console.log(data);    
            this.recvrList = data.goodsList;
            this.goods.recvr_nm = this.recvrList[0].recvr_nm;
           
            console.log(this.recvrList);

        })
     
    },
    components: {GoodDtl ,MainHeader, Footer}
}
</script>

